'use client';
import React, {useEffect, useState} from "react";
import {BubbleTip, FontIcon} from "@/app/_components";
import SCIcon from "@/app/_components/SCIcon/SCIcon";
import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import RouterMgr from "@/Core/RouterMgr";
import {DriveUtil} from "@/Master/DriveUtil";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {RedeemRecordDialogFC} from "@/app/(redeem)/redeemRecord/RedeemRecordDialogFC";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import Util from "@/Master/Util";
import BigTips from "@/Master/BigTips";
import {useAppDispatch, useAppSelector} from "@/app/storeHooks";
import {LoginType, selectUserInfo} from "@/app/userSlice";
import { getUserInfoGameBaseAsync} from "@/app/userSliceAPI";
import styles from "../(pages)/redeem/redeem.module.css";
import {RedeemSelectDialogFC} from "@/app/(redeem)/redeemSelect/RedeemSelectDialogFC";
import {RedeemConfigEntity} from "@/Core/Redeem/redeemEntity";
import WebRedeem from "@/Core/Redeem/WebRedeem";
import {HttpResponse} from "@/Fwk/Http/HttpConfig";
import {RedeemChannelType} from "@/Core/Redeem/RedeemChannelType";
import {selectMainState} from "@/app/MainSlice";
import {UpdateMainState} from "@/app/MainSliceUtil";
import AuthTrack, {LoginScene} from "@/Core/AuthTrack";

export default function RedeemUI() {
    const minRedeem = 50;
    const [redeemCheckData, setRedeemCheckData] = useState<ResponseRedeemCheckData>({} as ResponseRedeemCheckData);
    const userInfo = useAppSelector(selectUserInfo);
    const {isChannelOk, withdrawalThreshold, isKycPending} = useAppSelector(selectMainState);
    const dispatch = useAppDispatch();

    useEffect(() => {
        updateChannelCheckData();
    }, []);

    useEffect(() => {
        if (redeemCheckData){
            const {withdrawalThreshold,cashAppValidDays,isKycPending} = redeemCheckData;
            UpdateMainState('RedeemUI',{
                isKycPending:isKycPending,
                // isKycPending:true,
                cashAppValidDays:cashAppValidDays ? cashAppValidDays : 5,
                withdrawalThreshold:withdrawalThreshold ? withdrawalThreshold : minRedeem,
            });
        }
    }, [redeemCheckData]);

    const updateChannelCheckData = async () => {
        const channelType = RedeemChannelType.Paypal;
        const response = await WebRedeem.Instance.RequestRedeemCheck(channelType, (data: HttpResponse<ResponseRedeemCheckData>) => {
            if (Util.isLog) {
                console.log('updateChannelCheckData', data);
            }
        });
        if (response?.code == 200){
            setRedeemCheckData(response.data);
        }else{
            const msg = response?.message || response?.description;
            if (msg){
                BigTips.showMsg(msg);
            }
        }
    }

    const onRedeem = async () => {
        showForceLoading()
        if (userInfo.loginType != LoginType.normal) {
            hideForceLoading();
            AuthTrack.showLogin(LoginScene.Redeem);
            RouterMgr.login();
            return;
        }
        if (userInfo.availableScAmount < withdrawalThreshold) {
            hideForceLoading();
            BigTips.showMsg('Your current redeemable amount less than redeemable minimum!');
            return;
        }
        const {isOk, channelList} = await getRedeemXTGConfig();
        hideForceLoading();
        if (isOk){
            SDialogManagerFC.openDialog(RedeemSelectDialogFC,{
                fcKey:SDialogManagerFC.getFCKey(RedeemSelectDialogFC),
                channelList:channelList,
                onItemClick:(data:ResponseRedeemConfigData)=>{
                    // checkRedeemAccount();
                }
            });
        }else{
            BigTips.showMsg('get RedeemConfig Error');
        }
    }

    const onRedeemHistory = async () => {
        if (userInfo.loginType != LoginType.normal) {
            AuthTrack.showLogin(LoginScene.Redeem);
            RouterMgr.login();
            return;
        }

        //直接去提现历史页面
        SDialogManagerFC.openDialog(RedeemRecordDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(RedeemRecordDialogFC),
            onClose: (isOk: boolean) => {
                dispatch(getUserInfoGameBaseAsync());
            }
        })
    }

    const getRedeemXTGConfig:()=>Promise<RedeemConfigEntity> = async () => {
      return new Promise(resolve => {
          RedeemManager.GetRedeemConfig((res: RedeemConfigEntity) => {
              if (Util.isLog){
                  console.log('RedeemUI getRedeemConfig',res);
              }
              resolve(res)
          });
      })
    }

    const isShowDot = () => {
        return isKycPending;
    }

    return (
        <>
            <div className={`${styles.redeem}`}>
                <div className={`${styles.title_box} center`}>
                    <FontIcon icon={'s-safety'} style={{color: '#55FF3E'}}></FontIcon>
                    <span className={styles.title}>CASH REDEMPTION</span>
                    <div className={`btn ${styles.history} center`} onClick={() => {
                        onRedeemHistory();
                    }}>
                        <FontIcon icon={`s-wait ${styles.redeemHistoryIcon}`}></FontIcon>
                        {
                            isShowDot() && <div className={`dotAni`}></div>
                        }
                    </div>
                </div>
                <div className={`${styles.itemCenter}`}>
                    <div className={`${styles.itemCenterMore} center`}>
                        <div style={{position: 'relative',padding:'0.7rem 0.35rem 0px'}}>
                            <BubbleTip
                                text1="Sweepstakes Coins must be played at least once before being eligible for redemption as a cash prize. Sweepstakes Coin can be redeemed for 1 USD."
                                text2={`Redeem your Sweepstakes Coins winnings to your account. Available to Redeem must be minimum ${DriveUtil.ToScString(withdrawalThreshold,true)}.`}
                            />
                        </div>
                    </div>

                    <div className={`${styles.item} ${styles.scItem}`}>
                        <div className={`${styles.info}`}>Sweepstakes Coins Balance:</div>
                        <div className={`center ${styles.gold}`}>
                            <SCIcon cls={styles.goldIcon}></SCIcon>
                            <span
                                className={`${styles.val}`}>{DriveUtil.ToDollarString(DriveUtil.ToNormalUnit(userInfo.convertTotalScAmount))}</span>
                        </div>
                    </div>

                    <div className={`${styles.item} ${styles.itemTop} ${styles.redeemItem}`}>
                        <div className={`${styles.info}`}>Available to Redeem:</div>
                        <div className={`center ${styles.gold}`}>
                            <SCIcon cls={styles.goldIcon}></SCIcon>
                            <span className={`${styles.val}`} style={{color:'#19DF51'}}>{DriveUtil.ToDollarString(DriveUtil.ToNormalUnit(userInfo.convertAvailableScAmount))}</span>
                        </div>
                    </div>

                    <div className={`${styles.item} ${styles.itemTop} ${styles.balanceItem}`}>
                        <div className={`${styles.info}`}>UnPlayed Balance:</div>
                        <div className={`center ${styles.gold}`}>
                            <SCIcon cls={styles.goldIcon}></SCIcon>
                            <span
                                className={`${styles.val} err-color`}>{DriveUtil.ToDollarString(DriveUtil.ToNormalUnit(userInfo.convertRewardScAmount))}</span>
                        </div>
                    </div>
                </div>
            </div>
            {
                <button className={`btn ${styles.btn}`} type="submit" onClick={onRedeem}>
                    Redeem
                </button>
            }

            {/*<button className={`btn ${styles.btn}`} type="button" onClick={() => {*/}
            {/*    // GetRedeemConfigTest()*/}
            {/*}}>*/}
            {/*    RedeemSelectDialogFC*/}
            {/*</button>*/}


            {/*<button className={`btn ${styles.btn}`} type="submit" onClick={() => {*/}
            {/*    SDialogManagerFC.openDialog(RedeemKYCDialogFC);*/}
            {/*}}>*/}
            {/*    KYC*/}
            {/*</button>*/}

            {/*<button className={`btn ${styles.btn}`} type="submit" onClick={() => {*/}
            {/*    SDialogManagerFC.openDialog(RedeemFailDialogFC);*/}
            {/*}}>*/}
            {/*    KYC Fail*/}
            {/*</button>*/}


        </>
    )
}

